import type { Theme } from '@mui/material/styles';

export const rowMenuPaperSx = { boxShadow: (theme: Theme) => theme.customShadows.cardElevated } as const;

export const rowMenuListSx = { border: 1, borderColor: 'Neutrals.300', py: 0, bgcolor: 'common.white', borderRadius: 1 } as const;

export const rowMenuItemSx = {
  minHeight: (theme: Theme) => theme.controlHeight.small,
  pl: 2,
  '&:not(:last-of-type)': { borderBottom: 1, borderColor: 'Neutrals.300' },
} as const;
